<template>
  <div id="datatable-document-types-primary-column" :class="{ 'h-100': isBoxMode }">
    <div
      class="d-flex align-items-center"
      style="gap: .5rem"
      :class="{ 'justify-content-between': isBoxMode }"
    >
      <div
        class="d-flex flex-column align-items-start mr-2"
        :class="{ 'p-3': isBoxMode }"
      >
        <span class="mb-2" :class="{ 'name-box-container h4': isBoxMode }" :style="titleStyles" v-if="!hideTitle">
          {{ value[boxConfig.boxTitleKey] || value.alias || value.name}}
        </span>
        <p v-if="isBoxMode && !hideContent" :class="{ 'description-box-container': isBoxMode }" :style="contentStyles">
          {{ value[boxConfig.boxContentKey] || value.description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    isBoxMode: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      boxConfig: {
        boxTitleKey: 'alias',
        boxTitleLines: 2,
        boxContentKey: 'description',
        boxContentLines: 3
      }
    }
  },
  computed: {
    titleStyles () {
      return {
        '--datatable-box-mode-title-line-clamp': this.boxConfig.boxTitleLines
      }
    },
    contentStyles () {
      return {
        '--datatable-box-mode-content-line-clamp': this.boxConfig.boxContentLines
      }
    },
    hideTitle () {
      return this.config.boxTitleKey === 'NULL'
    },
    hideContent () {
      return this.config.boxContentKey === 'NULL'
    }
  },
  mounted () {
    for (const key in this.config) {
      if (this.boxConfig.hasOwnProperty(key)) {
        this.boxConfig[key] = this.config[key]
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.name-box-container
  overflow: hidden
  text-overflow: ellipsis
  display: -webkit-box
  line-clamp: var(--datatable-box-mode-title-line-clamp)
  -webkit-line-clamp: var(--datatable-box-mode-title-line-clamp)
  -webkit-box-orient: vertical
.description-box-container
  margin-bottom: 0
  overflow: hidden
  text-overflow: ellipsis
  display: -webkit-box
  line-clamp: var(--datatable-box-mode-content-line-clamp)
  -webkit-line-clamp: var(--datatable-box-mode-content-line-clamp)
  -webkit-box-orient: vertical
</style>
